import { Apollo } from 'src/gql/generated';

export function getVariableVariantDisplayString(variant: Apollo.MetadataVariant): string {
  switch (variant) {
    case Apollo.MetadataVariant.Currency:
    case Apollo.MetadataVariant.Decimal:
      return 'Number';
    case Apollo.MetadataVariant.Email:
    case Apollo.MetadataVariant.Text:
      return 'Text';
    case Apollo.MetadataVariant.Date:
      return 'Date';
    case Apollo.MetadataVariant.Options:
      return 'Dropdown';
    case Apollo.MetadataVariant.RadioOptions:
      return 'Radiobutton';
    case Apollo.MetadataVariant.Checkbox:
      return 'Checkbox';
  }
}
